import(/* webpackMode: "eager" */ "/tmp/8de89d872bc897a/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de89d872bc897a/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de89d872bc897a/src/app/metrics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de89d872bc897a/src/components/ClientInit/ClientInit.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de89d872bc897a/src/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de89d872bc897a/src/styles/global.scss");
